import type { SearchExamples } from '@gymcloud/set-search'

/**
 * How search works — the search spec, Saying how search works. Every kind of term a search of
 * training history reads, each with examples; an example is a search of the account's own
 * history where it holds one of that kind, and pressing one searches it.
 */
export function SearchHelp({
  examples,
  onSearch,
}: {
  examples: SearchExamples
  onSearch: (search: string) => void
}) {
  const rows: { title: string; what: string; examples: readonly string[] }[] = [
    {
      title: 'Words',
      what: 'An exercise, a note, a song, a workout or a template.',
      examples: examples.words,
    },
    {
      title: 'Weight and reps',
      what: 'A weight, reps, or both joined by an x, and ranges like 8-12 or 100+.',
      examples: examples.weightAndReps,
    },
    {
      title: 'Time, distance and effort',
      what: 'Seconds, minutes or a clock; kilometres, miles or metres; @ and an RPE.',
      examples: examples.timeDistanceEffort,
    },
    {
      title: 'Bodyweight',
      what: 'Sets of reps with no weight on them.',
      examples: examples.bodyweight,
    },
    {
      title: 'When',
      what: 'A month, a year or a date; a weekday or a time of day; days and weeks back.',
      examples: examples.when,
    },
    {
      title: 'Labels',
      what: 'A label and a colon ask one thing of a set — exercise, note, song, artist, album, workout, template, weight, reps, time, distance, rpe, on, after, before, is — and a minus leaves it out.',
      examples: examples.labels,
    },
  ]
  return (
    <section aria-label="How search works" className="space-y-3 px-1 py-1">
      <h2 className="text-xs font-medium tracking-wider text-ink-muted uppercase">
        How search works
      </h2>
      <ul className="space-y-3">
        {rows.map((row) => (
          <li key={row.title} className="space-y-1.5">
            <p className="text-sm">
              <span className="font-medium">{row.title}</span>{' '}
              <span className="text-ink-muted">{row.what}</span>
            </p>
            <div className="flex flex-wrap gap-2">
              {row.examples.map((example) => (
                <button
                  key={example}
                  type="button"
                  className="rounded-full px-3 py-1 text-sm ring-1 ring-white/15 transition-colors hover:bg-hover"
                  onClick={() => {
                    onSearch(example)
                  }}
                >
                  {example}
                </button>
              ))}
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
